import React from 'react'
import styled from '@emotion/styled'

export default function Slider({ volume, onChange }) {
  const styles = { volume }
  return (
    <Wrapper styles={styles}>
      <div className='slider'>
        <input
          type='range'
          value={volume}
          min={0}
          max={100}
          step={1}
          onChange={(e) => onChange(+e.target.value)}
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled('div')(({ styles: { volume } }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'column',
  borderRadius: '17px',
  padding: '0 .8rem',
  transform: 'rotate(0deg)',

  '.slider': {
    height: '32px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    input: {
      background: 'var(--text-white)',
      width: '100%',
      height: '2px',
      borderRadius: '5px',
      appearance: 'none',
      accentColor: !!volume ? 'var(--primary-player)' : 'var(--text-200)',
      cursor: 'pointer',
      ' :-webkit-slider-runnable-track': {
        height: '15px',
        background: ' #ff3333',
        borderRadius: '16px',
      },
    },
  },
}))
